<!-- Free Form Form -->
@if (freeFormStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="freeFormStyleForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.background_style">
      </h4>
      <!-- Background -->
      <medsurf-design-form-control-input-switch [control]="freeFormStyleForm.controls.background"
        [class]="'w-full'"
        [label]="'global.with_background'"
      (valueChange)="onShowBackground()"></medsurf-design-form-control-input-switch>
      <!-- Background In Border Color -->
      <medsurf-design-form-control-input-switch [hidden]="freeFormStyleForm.value.background === false"
        [control]="freeFormStyleForm.controls.backgroundInBorderColor"
        [class]="'w-full'"
        [label]="'global.background_in_border_color'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
      <!-- Background Color -->
      <medsurf-design-form-control-input-color-picker [hidden]="freeFormStyleForm.value.background === false"
        [control]="freeFormStyleForm.controls.color"
        [class]="'w-full'"
        [label]="'global.background_color'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <!-- Opacity -->
      <medsurf-design-form-control-input-slider [hidden]="freeFormStyleForm.value.background === false"
        [control]="freeFormStyleForm.controls.opacity"
        [class]="'w-full'"
        [isPercentage]="true"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
    </div>
  </medsurf-design-form-control-form>
}